// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

import Vuex from "vuex";
import router from "./router";
import APIFC from "./api/APIFC";
import store from "./store";

import { i18n } from "./plugins/i18n";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import theme from "./theme";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.css";
import "@mdi/font/css/materialdesignicons.css";
// import { aliases, fa } from 'vuetify/iconsets/fa'
import NotificationsWindow from "./components/Management/Notifications/NotificationsWindow.vue";
import VueDraggableResizable from "vue-draggable-resizable/src/index";
import "vue-draggable-resizable/src/components/vue-draggable-resizable.css";
import VTree from "vue-tree-halower";
import vSelect from "vue-select";
import Treeselect from "@riophae/vue-treeselect";
import Datepicker from "vuejs-datepicker";
import Toasted from "vue-toasted";
import VueGoogleCharts from "vue-google-charts";
import "es6-promise/auto";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
//import socket from "./api/socket";
import VueShowdown from "vue-showdown";

Bugsnag.start({
  apiKey: "6e800863ba0af5404bdea9fc23ae3d61",
  plugins: [new BugsnagPluginVue()],
  enabledReleaseStages: ["production", "development"],
  metadata: {
    user: {
      mail: localStorage.getItem("current_user_email")
    },
    company: {
      name: localStorage.getItem("company_name"),
      uuid: localStorage.getItem("company_uuid")
    },
    workspace: {
      name: sessionStorage.getItem("workspace_name"),
      uuid: sessionStorage.getItem("workspace_uuid")
    }
  }
});

Bugsnag.getPlugin("vue").installVueErrorHandler(Vue);

window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
if(process.env.NODE_ENV !== 'production'){
  heap.load("152183802");
}else{
  heap.load("2709611748");
}

export const bus = new Vue();
export const API = new APIFC();

Vue.component("vue-draggable-resizable", VueDraggableResizable);
Vue.component("v-select", vSelect);
Vue.component("datepicker", Datepicker);
Vue.component("treeselect", Treeselect);
Vue.component("notifications-window", NotificationsWindow);

require("./style/app.css");

require("./style/globals/colors.css");
require("./style/globals/display.css");
require("./style/globals/elements.css");

require("./style/modules/back_arrow.css");
require("./style/modules/cable_cluster_window.css");
require("./style/modules/datepicker.css");
require("./style/modules/form_input.css");
require("./style/modules/new_map.css");
require("./style/modules/photo_field.css");
require("./style/modules/modal.css");
require("./style/modules/map.css");
require("./style/modules/range.css");
require("./style/modules/remember_checkbox.sass");
require("./style/modules/scrollbar.css");
require("./style/modules/toast.css");
require("./style/modules/treeselect.css");
require("./style/modules/dialog.css");

require("./style/views/home/bottom_bar.css");
require("./style/views/home/example_form.css");
require("./style/views/login.css");
require("./style/views/network_form.css");
require("./style/views/password_recovery.css");
require("./style/views/home/side_bar.css");
require("./style/views/home/tools.css");
require("./style/views/theme-radio.css");
require("./style/views/home/table_forms.css");
require("./style/views/home/home.css");
require("./style/views/home/search.css");
require("./style/views/home/draggableResizable.css");

require("./style/views/management/forms.css");
require("./style/views/management/data_table.css");
require("./style/views/management/import_data.css");
require("./style/views/management/nav_bar.css");
require("./style/views/management/side_bar.css");
require("./style/views/management/networkRules.css");
require("./style/views/management/management.css");
require("./style/fonts/font.css");

Vue.use(VTree);
Vue.use(Vuetify);
Vue.use(VueMaterial);
Vue.use(Toasted, {});
Vue.use({ i18n });
Vue.use(VueGoogleCharts);
Vue.use(Vuex);
Vue.use(Loading);
Vue.use(VueShowdown);


import endpoints from "./utils/endpoints";
sessionStorage.setItem("is_bidding", endpoints.IS_BIDDING);


/**
 * Inserts the socket instance in Vue prototype to use in all components
 */
//Vue.prototype.$socket = io;

Vue.toasted.register("toast_success", message => message, {
  icon: "check",
  position: "bottom-left",
  duration: 5000,
  className: ["defaultToast", "successToast"],
  containerClass: "defaultToastContainer"
});

Vue.toasted.register("toast_error", message => message, {
  icon: "close",
  position: "bottom-left",
  duration: 5000,
  className: ["defaultToast", "errorToast"],
  containerClass: "defaultToastContainer"
});

Vue.toasted.register("toast_warning", message => message, {
  icon: "warning",
  position: "bottom-left",
  duration: 5000,
  className: ["defaultToast", "warningToast"],
  containerClass: "defaultToastContainer"
});

Vue.toasted.register("toast_info", message => message, {
  icon: "info",
  position: "bottom-left",
  duration: 5000,
  className: ["defaultToast", "infoToast"],
  containerClass: "defaultToastContainer"
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  vuetify: new Vuetify({
    theme,
    icons: {
      radioOn: "mdi-radiobox-marked",
      radioOff: "mdi-radiobox-blank",
      // defaultSet: 'fa',
      // aliases,
      // sets: {
      //   fa,
      // },
    }
  }),
  el: "#app",
  i18n,
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js